module.exports = __webpack_public_path__ + "static/media/emojis2_07.7f7f91bd.svg";